const DEFAULT_EPSILON = 1e-6;

const toNumber = (value, fallback = 0) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
};

export const equivalenciaCompraValida = (detalle) => {
  if (!detalle?.requierePack) return true;
  const cantidad = Number(detalle.cantidad);
  const total = Number(detalle.totalMP);
  const confirmado = detalle.coeficienteCompraConfirmado;
  return Boolean(String(detalle.unidadPack || "").trim()) &&
    Number.isFinite(cantidad) && cantidad > 0 && Number.isFinite(total) && total > 0 &&
    (confirmado == null || (Number.isFinite(Number(confirmado)) && Number(confirmado) > 0));
};

export const getUnitMultiplier = (multiplicador) => {
  const parsed = toNumber(multiplicador, 1);
  return parsed > 0 ? parsed : 1;
};

export const getPackCoefficient = (pedidoCompraDetalle = {}) => {
  const requiresPack =
    !!pedidoCompraDetalle?.requierePack && !!pedidoCompraDetalle?.unidadPack;
  if (!requiresPack) return 1;

  const confirmado = Number(pedidoCompraDetalle?.coeficienteCompraConfirmado);
  if (Number.isFinite(confirmado) && confirmado > 0) return confirmado;

  const totalMP = toNumber(pedidoCompraDetalle?.totalMP, NaN);
  const cantidad = toNumber(pedidoCompraDetalle?.cantidad, NaN);
  if (Number.isFinite(totalMP) && totalMP > 0 && Number.isFinite(cantidad) && cantidad > 0) {
    return totalMP / cantidad;
  }

  // Compatibilidad con datos legacy en los que solo venia equivalenciaPack.
  const legacyEquiv = toNumber(pedidoCompraDetalle?.equivalenciaPack?.materiaPrima, NaN);
  if (Number.isFinite(legacyEquiv) && legacyEquiv > 0) return legacyEquiv;

  return 1;
};

export const getProvisionDetailBaseFactor = ({ multiplicador, pedidoCompraDetalle }) => {
  return getUnitMultiplier(multiplicador) * getPackCoefficient(pedidoCompraDetalle);
};

export const toBaseQuantity = ({ quantityOriginal, multiplicador, pedidoCompraDetalle }) => {
  const factorBase = getProvisionDetailBaseFactor({ multiplicador, pedidoCompraDetalle });
  return toNumber(quantityOriginal, 0) * factorBase;
};

export const fromBaseQuantity = ({ quantityBase, multiplicador, pedidoCompraDetalle }) => {
  const factorBase = getProvisionDetailBaseFactor({ multiplicador, pedidoCompraDetalle });
  if (!factorBase) return 0;
  return toNumber(quantityBase, 0) / factorBase;
};

export const computePendingQuantity = ({
  requiredOriginal,
  deliveredOriginal,
  epsilon = DEFAULT_EPSILON,
}) => {
  const pendingRaw = toNumber(requiredOriginal, 0) - toNumber(deliveredOriginal, 0);
  if (pendingRaw <= epsilon) return 0;
  return Number(Math.max(0, pendingRaw).toFixed(6));
};

export const computeDeliveryPercentage = ({ delivered, incoming = 0, required }) => {
  const requiredQuantity = toNumber(required, 0);
  if (requiredQuantity <= 0) return 0;

  const projectedDelivery = toNumber(delivered, 0) + toNumber(incoming, 0);
  return Number(((projectedDelivery / requiredQuantity) * 100).toFixed(6));
};

